'use es6';

import createAction from 'flux-actions/createAction';
import { RECEIVED_TEMPLATE, REQUESTED_TEMPLATE, REQUESTED_TEMPLATE_FAILED } from './ActionTypes';
export const requestTemplate = createAction(REQUESTED_TEMPLATE);
export const receiveTemplate = createAction(RECEIVED_TEMPLATE, template => ({
  template
}));
export const requestedTemplateFailed = createAction(REQUESTED_TEMPLATE_FAILED, error => ({
  error
}));